import EverlanceIcon from './EverlanceIcon'
import EverlanceBusinessIcon from './EverlanceBusinessIcon'
import AllSelectedIcon from './AllSelectedIcon'
import HomeIcon from './HomeIcon'
import CrownIcon from './CrownIcon'
import BriefcaseIcon from './BriefcaseIcon'
import QuestionMarkIcon from './QuestionMarkIcon'
import CommuteIconFilled from './CommuteIconFilled'
import MovingIcon from './MovingIcon'
import HandHeartIcon from './HandHeartIcon'
import MedicalIcon from './MedicalIcon'
import BankCardIcon from './BankCardIcon'
import MarkerIcon from './MarkerIcon'
import TripsIcon from './TripsIcon'
import ForwardIcon from './ForwardIcon'
import DotIcon from './DotIcon'
import PhotographyIcon from './PhotographyIcon'
import PhysicianIcon from './PhysicianIcon'
import TutoringIcon from './TutoringIcon'
import ReligiousServicesIcon from './ReligiousServicesIcon'
import CoachingIcon from './CoachingIcon'
import RealEstateIcon from './RealEstateIcon'
import InsuranceIcon from './InsuranceIcon'
import CreativeIcon from './CreativeIcon'
import FoodServicesIcon from './FoodServicesIcon'
import ConsultantIcon from './ConsultantIcon'
import PaperclipIcon from './PaperclipIcon'
import MergeIcon from './MergeIcon'
import CarInMotionIcon from './CarInMotionIcon'
import CalculatorIcon from './CalculatorIcon'
import TeamsIcon from './TeamsIcon'
import VisaLogo from './VisaLogo'
import MastercardLogo from './MastercardLogo'
import AmericanExpressLogo from './AmericanExpressLogo'
import DiscoverLogo from './DiscoverLogo'
import DinersClubLogo from './DinersClubLogo'
import JCBLogo from './JCBLogo'
import ReturnOnInvestmentIconUnfilled from './ReturnOnInvestmentIconUnfilled'
import LockFilledIcon from './LockFilledIcon'
import InboxIcon from './InboxIcon'
import NewReportIcon from './NewReportIcon'
import PersonCircle from './PersonCircle'
import Person from './Person'
import DoordashLogo from './DoordashLogo'
import UberLogo from './UberLogo'
import InstacartLogo from './InstacartLogo'
import GopuffIcon from './GopuffIcon'
import ShiptIcon from './ShiptIcon'
import FavorIcon from './FavorIcon'
import WagIcon from './WagIcon'
import AmazonFlex from './AmazonFlex'
import SiGrubhub from 'core/_tmp/react-icons/SiGrubhub'
import TaskrabbitIcon from './TaskrabbitIcon'
import LyftLogo from './LyftLogo'
import AddTripIcon from './AddTripIcon'
import ViewReportsIcon from './ViewReportsIcon'
import MileageIcon from './MileageIcon'
import CameraIcon from './CameraIcon'
import PayPeriodEmptyIcon from './PayPeriodEmptyIcon'
import OneTimeReportsIcon from './OneTimeReportsIcon'
import TransactionsEmptyTableFeatureIcon from './TransactionsEmptyTableFeatureIcon'
import { IconSvgProps } from 'core/_legacy/icons/IconSvg'
import { LegacyIconType } from 'core/_legacy/icons/_types'
import SiThumbtack from 'core/_tmp/react-icons/SiThumbtack'

const awsS3MediaPath =
  'https://s3-us-west-2.amazonaws.com/everlance-dashboard-dev/static/media/income-source-icons/'
const awsS3MediaPath2 =
  'https://s3-us-west-2.amazonaws.com/everlance-dashboard-dev/static/media/custom-vehicle-icons/'

export {
  EverlanceIcon, // src/core/widgets/top-nav/TopNav.tsx
  EverlanceBusinessIcon, // src/core/widgets/modals/TeamWelcomeModal.tsx | src/pages/dashboard/accept-invite/AcceptTeamInvitePage.tsx
  AllSelectedIcon, // All purposes
  HomeIcon, // Personal purpose
  CrownIcon, // src/core/widgets/top-nav/TopNav.tsx | src/pages/dashboard/trips/ExportModal.tsx
  BriefcaseIcon, // src/pages/sign-up/SecondStep.tsx | src/pages/team/program/purposes/ProgramPurposesPage.tsx
  QuestionMarkIcon, // Unclassified purpose
  CommuteIconFilled, // Commute purpose
  MovingIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  HandHeartIcon, // Charity purpose
  MedicalIcon, // Medical purpose
  BankCardIcon, // src/pages/account/expense-sync/BankList.tsx | src/pages/account/expense-sync/SyncAccountsForm.tsx
  MarkerIcon, // src/pages/account/favorite-trips/FavoriteTripsDrawer.tsx
  TripsIcon, // src/pages/account/favorite-trips/FavoriteTrips.tsx
  ForwardIcon, // src/pages/account/expense-sync/BankCardDrawer.tsx | src/pages/account/expense-sync/BankList.tsx | src/pages/account/expense-sync/LoadingSkeleton.tsx | src/pages/account/expense-sync/UpdateLogin.tsx
  DotIcon, // src/core/widgets/trip-detail/PlaceFormItem.tsx | src/pages/dashboard/trips/Location.tsx
  PhotographyIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  PhysicianIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  TutoringIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  ReligiousServicesIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  CoachingIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  RealEstateIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  InsuranceIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  CreativeIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  FoodServicesIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  ConsultantIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  PaperclipIcon, // src/core/components/inputs/uploader/UploadList.tsx
  MergeIcon, // src/pages/dashboard/trips/TripsTable.tsx
  CarInMotionIcon, // src/pages/dashboard/trips/TripsPage.tsx | src/pages/dashboard/trips/TripsTable.tsx | src/pages/shared/report/add-drawer/TripsTab.tsx | src/pages/teams/members/detail-drawer/tabs/TripsTab.tsx
  CalculatorIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  TeamsIcon, // src/pages/sign-up/AboutYouPage.tsx | src/pages/sign-up/FirstStep.tsx
  VisaLogo, // src/pages/shared/premium/payment-method/PaymentMethodCard.tsx
  MastercardLogo, // src/pages/shared/premium/payment-method/PaymentMethodCard.tsx
  AmericanExpressLogo, // src/pages/shared/premium/payment-method/PaymentMethodCard.tsx
  DiscoverLogo, // src/pages/shared/premium/payment-method/PaymentMethodCard.tsx
  DinersClubLogo, // src/pages/shared/premium/payment-method/PaymentMethodCard.tsx
  JCBLogo, // src/pages/shared/premium/payment-method/PaymentMethodCard.tsx
  ReturnOnInvestmentIconUnfilled, // src/pages/teams/reimbursements/pay-period-detail/Summary.tsx
  LockFilledIcon, // src/core/widgets/purpose/Purpose.tsx | src/core/widgets/transaction-detail/TransactionDetail.tsx | src/core/widgets/trip-detail/TripDetail.tsx
  InboxIcon, // Income source, comes from BE
  NewReportIcon, // src/pages/dashboard/reports/ReportsPage.tsx
  PersonCircle, // src/core/widgets/top-nav/ProfilePopover.tsx
  Person, // src/pages/sign-up/AboutYouPage.tsx | src/pages/sign-up/FirstStep.tsx
  DoordashLogo, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx | src/pages/sign-up/FirstStep.tsx
  UberLogo, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx | src/pages/sign-up/FirstStep.tsx
  InstacartLogo, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx | src/pages/sign-up/FirstStep.tsx
  GopuffIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  ShiptIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  FavorIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  WagIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  AmazonFlex, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  SiGrubhub, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  TaskrabbitIcon, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx
  LyftLogo, // src/pages/account/purposes/resources.tsx | src/pages/sign-up/resources.tsx | src/pages/sign-up/FirstStep.tsx
  AddTripIcon, // src/core/widgets/modals/WelcomeModal.tsx
  ViewReportsIcon, // src/core/widgets/modals/WelcomeModal.tsx
  MileageIcon, // src/core/widgets/modals/WelcomeModal.tsx
  CameraIcon, // src/core/widgets/transaction-detail/FilePicker.tsx
  PayPeriodEmptyIcon, // src/pages/teams/reimbursements/PayPeriodsTable.tsx
  OneTimeReportsIcon, // src/pages/teams/reimbursements/OneOffReportTab.tsx
  TransactionsEmptyTableFeatureIcon // src/pages/dashboard/transactions/TransactionsPage.tsx | src/pages/dashboard/transactions/TransactionsTable.tsx | src/pages/shared/report/add-drawer/TransactionsTab.tsx | src/pages/teams/members/detail-drawer/tabs/ExpensesTab.tsx
}

interface LegacyIconProps
  extends Pick<IconSvgProps, 'color' | 'width' | 'height'> {
  selected?: boolean
  type: LegacyIconType
  defaultType?: LegacyIconType
}

export const LegacyIcon = ({
  type,
  height,
  selected = false,
  width = 25,
  color = '',
  defaultType
}: LegacyIconProps) => {
  const alt = `Legacy Icon [${type}]`
  const LegacyIcons: Record<LegacyIconType, JSX.Element> = {
    // Income sources from BE - START
    'Real Estate': <RealEstateIcon {...{ width, height, color }} />,
    Photography: <PhotographyIcon {...{ width, height, color }} />,
    Uber: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath}uber_logo${selected ? '' : '-grey'}.png`}
      />
    ),
    Lyft: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath}Lyftlogo-100${selected ? '' : '-grey'}.png`}
      />
    ),
    Insurance: <InsuranceIcon {...{ width, height, color }} />,
    // missing: Field Nation
    'Tax Pro': <CalculatorIcon {...{ width, height, color }} />,
    // missing: Home Services
    Doordash: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath}Doordashlogo-100${selected ? '' : '-grey'}.png`}
      />
    ),
    Instacart: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath}Instacartlogo-100${selected ? '' : '-grey'}.png`}
      />
    ),
    Creative: <CreativeIcon {...{ width, height, color }} />,
    Taskrabbit: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath}Taskrabbitlogo-100${
          selected ? '' : '-grey'
        }.png`}
      />
    ),
    Airbnb: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath}Airbnblogo-100${selected ? '' : '-grey'}.png`}
      />
    ),
    Postmates: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath}Postmateslogo-100${selected ? '' : '-grey'}.png`}
      />
    ),
    Wonolo: (
      <img
        alt={alt}
        width={width}
        style={selected ? {} : { filter: 'saturate(0%) opacity(30%)' }}
        src={`${awsS3MediaPath}Wonolologo.png`}
      />
    ),
    Favor: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath}Favorlogo${selected ? '' : '-grey'}.png`}
      />
    ),
    Shipt: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath}Shipt-100${selected ? '' : '-grey'}.png`}
      />
    ),
    'Food Services': <FoodServicesIcon {...{ width, height, color }} />,
    Coaching: <CoachingIcon {...{ width, height, color }} />,
    Tutoring: <TutoringIcon {...{ width, height, color }} />,
    Trucking: <MovingIcon {...{ width, height, color }} />,
    'Religious Services': (
      <ReligiousServicesIcon {...{ width, height, color }} />
    ),
    Physician: <PhysicianIcon {...{ width, height, color }} />,
    Consultant: <ConsultantIcon {...{ width, height, color }} />,
    // missing: Legal
    Other: <InboxIcon {...{ width, height, color }} />,
    'Amazon Flex': <AmazonFlex {...{ width, height, color }} />,
    Grubhub: <SiGrubhub {...{ width, height, color }} />,
    Wag: <WagIcon {...{ width, height, color }} />,
    GoPuff: <GopuffIcon {...{ width, height, color }} />,
    Thumbtack: <SiThumbtack {...{ width, height, color }} />,
    // Income sources from BE - END

    // Purposes from BE - START
    // this one doesn't come from BE, but it's used as the selector's placeholder
    'All purposes': <AllSelectedIcon {...{ width, height, color }} />,
    work: <BriefcaseIcon {...{ width, height, color }} />,
    Work: <BriefcaseIcon {...{ width, height, color }} />,
    Personal: <HomeIcon {...{ width, height, color }} />,
    Commute: <CommuteIconFilled {...{ width, height, color }} />,
    Medical: <MedicalIcon {...{ width, height, color }} />,
    Moving: <MovingIcon {...{ width, height, color }} />,
    Charity: <HandHeartIcon {...{ width, height, color }} />,

    // this one doesn't come from BE, but it's used when there is no purpose
    Unclassified: <QuestionMarkIcon {...{ width, height, color }} />,
    // Purposes from BE - END

    // More icons
    Marker: <MarkerIcon {...{ width, height, color }} />,
    CarInMotion: <CarInMotionIcon {...{ width, height, color }} />,

    // TODO business icons remain .png since they don't exist in icons8
    Caviar: (
      <img
        alt={alt}
        width={width}
        style={selected ? {} : { filter: 'saturate(0%) opacity(30%)' }}
        src={`${awsS3MediaPath}Caviarlogo.png`}
      />
    ),
    Vehicle: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Car+Filled-100.png`}
      />
    ),
    Sedan: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Sedan+Filled-100-2.png`}
      />
    ),
    Truck: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Truck+filled+100.png`}
      />
    ),
    'Prop Plane': (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Prop+Plane+Filled-100.png`}
      />
    ),
    PropPlane: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Prop+Plane+Filled-100.png`}
      />
    ),
    'Wright Brothers': (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Prop+Plane+Filled-100.png`}
      />
    ),
    'Pioneer Wagon': (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Pioneer+Wagon+Filled-100.png`}
      />
    ),
    Wagon: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Pioneer+Wagon+Filled-100.png`}
      />
    ),
    Pickup: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Pickup+filled+100-1.png`}
      />
    ),
    'Launched Rocket': (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Launched+Rocket+Filled-100.png`}
      />
    ),
    Rocket: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Launched+Rocket+Filled-100.png`}
      />
    ),
    'Apollo 13': (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Launched+Rocket+Filled-100.png`}
      />
    ),
    'Go Kart': (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Go+Kart+Filled-100.png`}
      />
    ),
    GoKart: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Go+Kart+Filled-100.png`}
      />
    ),
    'F1 Race Car Side View': (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}F1+Race+Car+Side+View+Filled-100.png`}
      />
    ),
    RaceCar: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}F1+Race+Car+Side+View+Filled-100.png`}
      />
    ),
    'Formula One': (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}F1+Race+Car+Side+View+Filled-100.png`}
      />
    ),
    Convertible: (
      <img
        alt={alt}
        width={width}
        src={`${awsS3MediaPath2}Convertible+Filled-100.png`}
      />
    )
  }

  let icon
  if (Object.keys(LegacyIcons).includes(type)) {
    icon = LegacyIcons[type]
  } else if (defaultType) {
    icon = LegacyIcons[defaultType]
  } else {
    // TODO ADD correct default icon
    icon = <BriefcaseIcon {...{ width, height, color }} />
  }
  return icon
}
